import { createFileRoute } from '@tanstack/react-router';

import { ApprovalRulesPage } from '@/features/approvals/rules-page';

export const Route = createFileRoute('/_app/org/$orgId/approval-rules')({
  component: ApprovalRulesRoute,
});

function ApprovalRulesRoute() {
  const { orgId } = Route.useParams();
  return <ApprovalRulesPage orgId={orgId} />;
}
